export const COURSE_STATE = {
  ACT: 'ACTIVE',
  INACT: 'INACTIVE',
  PSD: 'PAUSED',
  NOT_ENROLLED: 'NOT_ENROLLED',
  MAX_ACTIVE: 'MAX_ACTIVE',
  READMIT: 'READMIT',
  SUSPENDED: 'SUSPENDED',
};
